import { LanguageState }  from '../../reduxTypes';

export interface LanguageToggleProps {
    context: string;
    dealerLanguages: string[];
    recipientLanguage?: string;
    dispatchLanguage: (language: string) => void;
    features: number[];
    languageStore: LanguageState;
    translate: (label: string) => string;
}

export enum Languages {
    en = 'english',
    fr = 'french',
    es = 'spanish',
    yue = 'cantonese',
    cmn = 'mandarin'
}



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/LanguageToggleTypes.ts